import { schema } from 'normalizr'

// Circular Dependencies - Use the define method
// const item = new schema.Entity('item')
// const child = new schema.Entity('child')
// item.define({ children: [child] })

// Define Entities
// START ENTITY DEFINITIONS
const activity = new schema.Entity('activities')
const adCopy = new schema.Entity('adCopies')
const address = new schema.Entity('addresses')
const agency = new schema.Entity('agencies')
const agencyContact = new schema.Entity('agencyContacts')
const agencyOrderBundle = new schema.Entity('agencyOrderBundles')
const agencyPaymentMethod = new schema.Entity('agencyPaymentMethods')
const agencyPortal = new schema.Entity('agencyPortals')
const agencyProvider = new schema.Entity('agencyProviders')
const agencyProviderDeadlineGroup = new schema.Entity('agencyProviderDeadlineGroups')
const agencyProviderPackage = new schema.Entity('agencyProviderPackages')
const agencyProviderPriceOverride = new schema.Entity('agencyProviderPriceOverrides')
const agencyPublication = new schema.Entity('agencyPublications')
const agencyTag = new schema.Entity('agencyTags')
const agent = new schema.Entity('agents')
const apiKey = new schema.Entity('apiKeys')
const apiLog = new schema.Entity('apiLogs')
const artwork = new schema.Entity('artworks')
const artworkPage = new schema.Entity('artworkPages')
const artworkReview = new schema.Entity('artworkReviews')
const assetLibrary = new schema.Entity('assetLibraries')
const attachment = new schema.Entity('attachments')
const auditLog = new schema.Entity('auditLogs')
const billingType = new schema.Entity('billingTypes')
const booking = new schema.Entity('bookings')
const brand = new schema.Entity('brands')
const brandColour = new schema.Entity('brandColours')
const brandCustomProfile = new schema.Entity('brandCustomProfiles')
const brandGroup = new schema.Entity('brandGroups')
const brandGroupMember = new schema.Entity('brandGroupMembers')
const brandGroupProvider = new schema.Entity('brandGroupProviders')
const brandGroupPublication = new schema.Entity('brandGroupPublications')
const brandProvider = new schema.Entity('brandProviders')
const brandTheme = new schema.Entity('brandThemes')
const campaign = new schema.Entity('campaigns')
const campaignCategory = new schema.Entity('campaignCategories')
const campaignCommercialCategory = new schema.Entity('campaignCommercialCategories')
const campaignComparable = new schema.Entity('campaignComparables')
const campaignContact = new schema.Entity('campaignContacts')
const campaignContribution = new schema.Entity('campaignContributions')
const campaignDocument = new schema.Entity('campaignDocuments')
const campaignInspection = new schema.Entity('campaignInspections')
const campaignItem = new schema.Entity('campaignItems')
const campaignPortal = new schema.Entity('campaignPortals')
const campaignPortalSync = new schema.Entity('campaignPortalSyncs')
const campaignQuote = new schema.Entity('campaignQuotes')
const campaignQuoteItem = new schema.Entity('campaignQuoteItems')
const campaignQuoteSection = new schema.Entity('campaignQuoteSections')
const campaignQuoteTemplate = new schema.Entity('campaignQuoteTemplates')
const campaignQuoteTemplateItem = new schema.Entity('campaignQuoteTemplateItems')
const campaignQuoteTemplateSection = new schema.Entity('campaignQuoteTemplateSections')
const campaignRuralCategory = new schema.Entity('campaignRuralCategories')
const campaignSaleMethod = new schema.Entity('campaignSaleMethods')
const campaignStatus = new schema.Entity('campaignStatuses')
const campaignType = new schema.Entity('campaignTypes')
const chartData = new schema.Entity('chartData')
const comment = new schema.Entity('comments')
const contact = new schema.Entity('contacts')
const contract = new schema.Entity('contracts')
const conversation = new schema.Entity('conversations')
const creditNote = new schema.Entity('creditNotes')
const creditNoteItem = new schema.Entity('creditNoteItems')
const customDeadline = new schema.Entity('customDeadlines')
const customField = new schema.Entity('customFields')
const customFieldSet = new schema.Entity('customFieldSets')
const customItem = new schema.Entity('customItems')
const customItemGroup = new schema.Entity('customItemGroups')
const customShortcode = new schema.Entity('customShortcodes')
const dataStoreItem = new schema.Entity('dataStoreItems')
const defaultQuoteItem = new schema.Entity('defaultQuoteItems')
const digitalTemplate = new schema.Entity('digitalTemplates')
const favouriteOrder = new schema.Entity('favouriteOrders')
const favouriteOrderItem = new schema.Entity('favouriteOrderItems')
const financeApplication = new schema.Entity('financeApplications')
const font = new schema.Entity('fonts')
const fontFamily = new schema.Entity('fontFamilies')
const geoCountry = new schema.Entity('geoCountries')
const geoState = new schema.Entity('geoStates')
const geoSuburb = new schema.Entity('geoSuburbs')
const image = new schema.Entity('images')
const imageLibrary = new schema.Entity('imageLibraries')
const integration = new schema.Entity('integrations')
const interactiveImage = new schema.Entity('interactiveImages')
const invoice = new schema.Entity('invoices')
const invoiceAttachment = new schema.Entity('invoiceAttachments')
const invoiceItem = new schema.Entity('invoiceItems')
const layoutTemplate = new schema.Entity('layoutTemplates')
const loginSession = new schema.Entity('loginSessions')
const mediaLink = new schema.Entity('mediaLinks')
const microsite = new schema.Entity('microsites')
const notification = new schema.Entity('notifications')
const order = new schema.Entity('orders')
const orderBundle = new schema.Entity('orderBundles')
const orderBundleItem = new schema.Entity('orderBundleItems')
const orderItem = new schema.Entity('orderItems')
const orderItemTask = new schema.Entity('orderItemTasks')
const orderItemTaskAttachment = new schema.Entity('orderItemTaskAttachments')
const orderItemTaskType = new schema.Entity('orderItemTaskTypes')
const orderLeadTime = new schema.Entity('orderLeadTimes')
const paginationRule = new schema.Entity('paginationRules')
const paymentMethod = new schema.Entity('paymentMethods')
const portal = new schema.Entity('portals')
const portalOption = new schema.Entity('portalOptions')
const portalOptionValue = new schema.Entity('portalOptionValues')
const pricingPlan = new schema.Entity('pricingPlans')
const priorityCampaign = new schema.Entity('priorityCampaigns')
const processingFee = new schema.Entity('processingFees')
const provider = new schema.Entity('providers')
const providerAccount = new schema.Entity('providerAccounts')
const providerDeadlineGroup = new schema.Entity('providerDeadlineGroups')
const providerDisclaimer = new schema.Entity('providerDisclaimers')
const providerOrderCode = new schema.Entity('providerOrderCodes')
const providerPackage = new schema.Entity('providerPackages')
const providerPackageItem = new schema.Entity('providerPackageItems')
const providerPriceList = new schema.Entity('providerPriceLists')
const providerPriceListItem = new schema.Entity('providerPriceListItems')
const providerPriceListItemOption = new schema.Entity('providerPriceListItemOptions')
const providerPriceListItemOptionValue = new schema.Entity('providerPriceListItemOptionValues')
const providerPriceListProductUnlock = new schema.Entity('providerPriceListProductUnlocks')
const providerProductCode = new schema.Entity('providerProductCodes')
const providerService = new schema.Entity('providerServices')
const publication = new schema.Entity('publications')
const publicationBooking = new schema.Entity('publicationBookings')
const publicationBookingItem = new schema.Entity('publicationBookingItems')
const publicationCompatiblePagination = new schema.Entity('publicationCompatiblePaginations')
const publicationEdition = new schema.Entity('publicationEditions')
const publicationInspection = new schema.Entity('publicationInspections')
const publicationOption = new schema.Entity('publicationOptions')
const publicationOptionValue = new schema.Entity('publicationOptionValues')
const publicationOrder = new schema.Entity('publicationOrders')
const publicationPaginationRule = new schema.Entity('publicationPaginationRules')
const publicationProduct = new schema.Entity('publicationProducts')
const publicationSpecialDeadline = new schema.Entity('publicationSpecialDeadlines')
const role = new schema.Entity('roles')
const savedArtwork = new schema.Entity('savedArtworks')
const savedArtworkPage = new schema.Entity('savedArtworkPages')
const service = new schema.Entity('services')
const serviceCategory = new schema.Entity('serviceCategories')
const serviceProduct = new schema.Entity('serviceProducts')
const smsLog = new schema.Entity('smsLogs')
const status = new schema.Entity('statuses')
const subscriber = new schema.Entity('subscribers')
const system = new schema.Entity('systems')
const tag = new schema.Entity('tags')
const team = new schema.Entity('teams')
const teamMember = new schema.Entity('teamMembers')
const templatePage = new schema.Entity('templatePages')
const templatePageCategory = new schema.Entity('templatePageCategories')
const trackingLink = new schema.Entity('trackingLinks')
const trainingCourse = new schema.Entity('trainingCourses')
const trainingLesson = new schema.Entity('trainingLessons')
const trainingModule = new schema.Entity('trainingModules')
const user = new schema.Entity('users')
const webhook = new schema.Entity('webhooks')
// END ENTITY DEFINITIONS

// Define Relationships
agency.define({
  agency_providers: [agencyProvider],
  agency_provider_packages: [agencyProviderPackage],
  agency_publications: [agencyPublication],
  attachments: [attachment],
  brand,
  contracts: [contract],
  deadline_groups: [agencyProviderDeadlineGroup],
  locked_by_user: user,
  agency_order_bundles: [agencyOrderBundle],
  payment_methods: [agencyPaymentMethod],
  portals: [agencyPortal],
  provider_account: providerAccount,
  support_team_users: [user],
})

agencyOrderBundle.define({
  agency,
  order_bundle: orderBundle,
})

agencyPaymentMethod.define({
  payment_method: paymentMethod,
})

agencyPortal.define({
  agency,
  portal,
  portals: [portal],
})

agencyProvider.define({
  agency,
  provider,
  provider_price_list: providerPriceList,
  service,
})

agencyProviderDeadlineGroup.define({
  provider,
  provider_deadline_group: providerDeadlineGroup,
})

agencyProviderPackage.define({
  agency,
  provider_package: providerPackage,
})

agencyProviderPriceOverride.define({
  provider_price_list: providerPriceList,
})

agencyPublication.define({
  agency,
  publication,
})

agent.define({
  user,
})

apiKey.define({
  user,
})

apiKey.define({
  actioned_by: user,
  webhook,
})

apiLog.define({
  actioned_by: user,
})

artwork.define({
  artwork_reviews: [artworkReview],
  pages: [artworkPage],
})

artworkPage.define({
  attachments: [attachment],
})

assetLibrary.define({
  agency,
  attachments: [attachment],
  brand,
})

attachment.define({
  order_item: orderItem,
})

brand.define({
  agencies: [agency],
  brand_groups: [brandGroup],
  pagination_rules: [paginationRule],
  public_link_cover_image: attachment,
  public_link_logo: attachment,
})

brandProvider.define({
  brand,
  provider,
})

brandTheme.define({
  brand,
})

brandGroupProvider.define({
  brand_group: brandGroup,
  provider,
})

brandGroupPublication.define({
  brand_group: brandGroup,
  publication,
})

brandGroup.define({
  brand,
})

campaign.define({
  ad_copies: [adCopy],
  agency,
  agents: [agent],
  campaign_category: campaignCategory,
  campaign_sale_method: campaignSaleMethod,
  data_store_items: [dataStoreItem],
  images: [image],
  inspections: [campaignInspection],
  media_links: [mediaLink],
  orders: {
    approved: [order],
    pending: [order],
  },
  team,
})

campaignContact.define({
  contact,
})

campaignContribution.define({
  campaign,
})

campaignComparable.define({
  image,
})

campaignInspection.define({
  campaign,
})

campaignPortal.define({
  portal,
})

campaignPortalSync.define({
  campaign,
  portal,
})

campaignQuote.define({
  campaign,
  campaign_items: [campaignItem],
  campaign_quote_template: campaignQuoteTemplate,
  invoices: [invoice],
  items: [campaignQuoteItem],
  orders: [order],
  sections: [campaignQuoteSection],
})

campaignQuoteItem.define({
  artwork,
  campaign_quote: campaignQuote,
  campaign_quote_items: [campaignQuoteItem],
  publication,
  publication_edition: publicationEdition,
  // publication_package: publicationPackage,
  quote_dynamic_items: [campaignQuoteItem],
  service,
  service_product: serviceProduct,
})

campaignQuoteTemplate.define({
  items: [campaignQuoteTemplateItem],
  sections: [campaignQuoteTemplateSection],
})

campaignQuoteTemplateItem.define({
  publication,
  quote_template_dynamic_items: [campaignQuoteTemplateItem],
})

comment.define({
  user,
  attachments: [attachment],
})

contact.define({
  user,
})

contract.define({
  attachments: [attachment],
})

conversation.define({
  artwork,
  comments: [comment],
  last_comment: comment,
  subscribers: [subscriber],
})

creditNote.define({
  campaign,
  items: [creditNoteItem],
})

customFieldSet.define({
  fields: [customField],
})

customItem.define({
  custom_item_group: customItemGroup,
})

customItemGroup.define({
  items: [customItem],
})

dataStoreItem.define({
  digital_template: digitalTemplate,
  user,
})

defaultQuoteItem.define({
  provider,
})

favouriteOrder.define({
  agency,
  items: [favouriteOrderItem],
})

financeApplication.define({
  campaign_contribution: campaignContribution,
})

font.define({
  font_family: fontFamily,
})

imageLibrary.define({
  agency,
  brand,
  cover_image: image,
  team,
})

loginSession.define({
  user,
})

invoice.define({
  agency,
  attachments: [invoiceAttachment],
  brand,
  booking,
  campaign,
  provider,
  package: providerPackage,
  users: [user],
  items: [invoiceItem],
})

notification.define({
  agency,
  artwork,
  brand,
  campaign,
  campaign_portal_sync: campaignPortalSync,
  custom_deadline: customDeadline,
  image,
  provider,
})

order.define({
  agency,
  campaign,
  items: [orderItem],
  provider,
  publication,
  publication_booking: publicationBooking,
  publication_edition: publicationEdition,
  // publication_package: publicationPackage,
  status,
})

orderBundle.define({
  agency_order_bundles: [agencyOrderBundle],
  items: [orderBundleItem],
})

orderBundleItem.define({
  price_list: providerPriceList,
  provider,
  publication,
})

orderItem.define({
  ad_copies: [adCopy],
  artwork,
  agents: [agent],
  attachments: [attachment],
  campaign,
  interactive_image: interactiveImage,
  last_completed_task: orderItemTask,
  microsite,
  order,
  service,
  service_product: serviceProduct,
  tasks: [orderItemTask],
})

orderItemTask.define({
  attachments: [orderItemTaskAttachment],
  order_item: orderItem,
  task_type: orderItemTaskType,
  provider_employee_user: user,
})

orderLeadTime.define({
  service,
  service_product: serviceProduct,
})

paginationRule.define({
  brand,
})

portal.define({
  portal_options: [portalOption],
})

portalOption.define({
  values: [portalOptionValue],
})

priorityCampaign.define({
  campaign,
  user,
})

processingFee.define({
  service_product: serviceProduct,
})

provider.define({
  deadline_groups: [providerDeadlineGroup],
  disclaimers: [providerDisclaimer],
  price_lists: [providerPriceList],
  webhooks: [webhook],
})

providerAccount.define({
  agency,
  provider,
})

providerDisclaimer.define({
  service_product: serviceProduct,
})

providerOrderCode.define({
  provider_price_list: providerPriceList,
  service_product: serviceProduct,
})

providerPackage.define({
  items: [providerPackageItem],
  provider,
})

providerPackageItem.define({
  price_list: providerPriceList,
})

providerPriceList.define({
  providers: [agencyProvider],
  items: [providerPriceListItem],
  next_price_list: providerPriceList,
  previous_price_list: providerPriceList,
  products: [serviceProduct],
  provider,
  service,
})

providerPriceListItem.define({
  options: [providerPriceListItemOption],
})

providerPriceListItemOption.define({
  values: [providerPriceListItemOptionValue],
})

providerPriceListProductUnlock.define({
  unlock_price_list: providerPriceList,
})

providerProductCode.define({
  product: serviceProduct,
})

publication.define({
  brand_group_member: brandGroupMember,
  editions: [publicationEdition],
  products: [publicationProduct],
  provider,
  publication_options: [publicationOption],
})

publicationEdition.define({
  publication,
})

publicationBooking.define({
  brand_group: brandGroup,
  items: [publicationBookingItem],
  publication,
  publication_edition: publicationEdition,
  publication_order: publicationOrder,
  publication_product: publicationProduct,
})

publicationBookingItem.define({
  agency,
  artwork,
  campaign,
  order,
  publication_booking: publicationBooking,
  brand_group: brandGroup,
  items: [publicationBookingItem],
  preflighted_by: user,
  publication_edition: publicationEdition,
  publication_order: publicationOrder,
  publication_product: publicationProduct,
  publication,
})

publicationCompatiblePagination.define({
  compatible_publication: publication,
})

publicationInspection.define({
  campaign,
  publication_edition: publicationEdition,
  publication,
})

publicationOrder.define({
  bookings: [publicationBooking],
})

publicationOption.define({
  values: [publicationOptionValue],
})

publicationPaginationRule.define({
  pagination_rule: paginationRule,
  publication,
})

publicationSpecialDeadline.define({
  publication_edition: publicationEdition,
})

savedArtwork.define({
  first_page: savedArtworkPage,
  user,
})

savedArtworkPage.define({
  user,
})

service.define({
  categories: [serviceCategory],
})

serviceCategory.define({
  service,
})

serviceProduct.define({
  assigned_publications: [publication],
  compatible_products: [serviceProduct],
  editorial_publications: [publication],
  items: [providerPriceListItem],
  service,
})

subscriber.define({
  user,
})

tag.define({
  brand,
})

team.define({
  agent_members: [teamMember],
  cover_image: image,
  image_library: imageLibrary,
  team_members: [teamMember],
})

teamMember.define({
  user,
})

templatePage.define({
  brand,
  service_products: [serviceProduct],
})

templatePageCategory.define({
  brand,
})

trainingLesson.define({
  training_module: trainingModule,
})

trainingModule.define({
  training_course: trainingCourse,
})

// @ts-expect-error TS2345
user.define({
  api_keys: [apiKey],
  association: (value) => {
    if (value.association_type === 'Agency') return agency
    if (value.association_type === 'Brand') return brand
    if (value.association_type === 'Provider') return provider
  },
  ebu_assigned_users: [user],
  image,
  images: [image],
  impersonated_user: user,
  integrations: [integration],
  media_links: [mediaLink],
  support_team_users: [user],
})

// Export Schemas
export const Schemas = {
// START SCHEMA DEFINITION
  ACTIVITY: activity,
  ACTIVITY_ARRAY: [activity],
  ADDRESS: address,
  ADDRESS_ARRAY: [address],
  AD_COPY: adCopy,
  AD_COPY_ARRAY: [adCopy],
  AGENCY: agency,
  AGENCY_ARRAY: [agency],
  AGENCY_CONTACT: agencyContact,
  AGENCY_CONTACT_ARRAY: [agencyContact],
  AGENCY_ORDER_BUNDLE: agencyOrderBundle,
  AGENCY_ORDER_BUNDLE_ARRAY: [agencyOrderBundle],
  AGENCY_PAYMENT_METHOD: agencyPaymentMethod,
  AGENCY_PAYMENT_METHOD_ARRAY: [agencyPaymentMethod],
  AGENCY_PORTAL: agencyPortal,
  AGENCY_PORTAL_ARRAY: [agencyPortal],
  AGENCY_PROVIDER: agencyProvider,
  AGENCY_PROVIDER_ARRAY: [agencyProvider],
  AGENCY_PROVIDER_DEADLINE_GROUP: agencyProviderDeadlineGroup,
  AGENCY_PROVIDER_DEADLINE_GROUP_ARRAY: [agencyProviderDeadlineGroup],
  AGENCY_PROVIDER_PACKAGE: agencyProviderPackage,
  AGENCY_PROVIDER_PACKAGE_ARRAY: [agencyProviderPackage],
  AGENCY_PROVIDER_PRICE_OVERRIDE: agencyProviderPriceOverride,
  AGENCY_PROVIDER_PRICE_OVERRIDE_ARRAY: [agencyProviderPriceOverride],
  AGENCY_PUBLICATION: agencyPublication,
  AGENCY_PUBLICATION_ARRAY: [agencyPublication],
  AGENCY_TAG: agencyTag,
  AGENCY_TAG_ARRAY: [agencyTag],
  AGENT: agent,
  AGENT_ARRAY: [agent],
  API_KEY: apiKey,
  API_KEY_ARRAY: [apiKey],
  API_LOG: apiLog,
  API_LOG_ARRAY: [apiLog],
  ARTWORK: artwork,
  ARTWORK_ARRAY: [artwork],
  ARTWORK_PAGE: artworkPage,
  ARTWORK_PAGE_ARRAY: [artworkPage],
  ARTWORK_REVIEW: artworkReview,
  ARTWORK_REVIEW_ARRAY: [artworkReview],
  ASSET_LIBRARY: assetLibrary,
  ASSET_LIBRARY_ARRAY: [assetLibrary],
  ATTACHMENT: attachment,
  ATTACHMENT_ARRAY: [attachment],
  AUDIT_LOG: auditLog,
  AUDIT_LOG_ARRAY: [auditLog],
  BILLING_TYPE: billingType,
  BILLING_TYPE_ARRAY: [billingType],
  BOOKING: booking,
  BOOKING_ARRAY: [booking],
  BRAND: brand,
  BRAND_ARRAY: [brand],
  BRAND_COLOUR: brandColour,
  BRAND_COLOUR_ARRAY: [brandColour],
  BRAND_CUSTOM_PROFILE: brandCustomProfile,
  BRAND_CUSTOM_PROFILE_ARRAY: [brandCustomProfile],
  BRAND_GROUP: brandGroup,
  BRAND_GROUP_ARRAY: [brandGroup],
  BRAND_GROUP_MEMBER: brandGroupMember,
  BRAND_GROUP_MEMBER_ARRAY: [brandGroupMember],
  BRAND_GROUP_PROVIDER: brandGroupProvider,
  BRAND_GROUP_PROVIDER_ARRAY: [brandGroupProvider],
  BRAND_GROUP_PUBLICATION: brandGroupPublication,
  BRAND_GROUP_PUBLICATION_ARRAY: [brandGroupPublication],
  BRAND_PROVIDER: brandProvider,
  BRAND_PROVIDER_ARRAY: [brandProvider],
  BRAND_THEME: brandTheme,
  BRAND_THEME_ARRAY: [brandTheme],
  CAMPAIGN: campaign,
  CAMPAIGN_ARRAY: [campaign],
  CAMPAIGN_CATEGORY: campaignCategory,
  CAMPAIGN_CATEGORY_ARRAY: [campaignCategory],
  CAMPAIGN_COMMERCIAL_CATEGORY: campaignCommercialCategory,
  CAMPAIGN_COMMERCIAL_CATEGORY_ARRAY: [campaignCommercialCategory],
  CAMPAIGN_COMPARABLE: campaignComparable,
  CAMPAIGN_COMPARABLE_ARRAY: [campaignComparable],
  CAMPAIGN_CONTACT: campaignContact,
  CAMPAIGN_CONTACT_ARRAY: [campaignContact],
  CAMPAIGN_CONTRIBUTION: campaignContribution,
  CAMPAIGN_CONTRIBUTION_ARRAY: [campaignContribution],
  CAMPAIGN_DOCUMENT: campaignDocument,
  CAMPAIGN_DOCUMENT_ARRAY: [campaignDocument],
  CAMPAIGN_INSPECTION: campaignInspection,
  CAMPAIGN_INSPECTION_ARRAY: [campaignInspection],
  CAMPAIGN_ITEM: campaignItem,
  CAMPAIGN_ITEM_ARRAY: [campaignItem],
  CAMPAIGN_PORTAL: campaignPortal,
  CAMPAIGN_PORTAL_ARRAY: [campaignPortal],
  CAMPAIGN_PORTAL_SYNC: campaignPortalSync,
  CAMPAIGN_PORTAL_SYNC_ARRAY: [campaignPortalSync],
  CAMPAIGN_QUOTE: campaignQuote,
  CAMPAIGN_QUOTE_ARRAY: [campaignQuote],
  CAMPAIGN_QUOTE_ITEM: campaignQuoteItem,
  CAMPAIGN_QUOTE_ITEM_ARRAY: [campaignQuoteItem],
  CAMPAIGN_QUOTE_SECTION: campaignQuoteSection,
  CAMPAIGN_QUOTE_SECTION_ARRAY: [campaignQuoteSection],
  CAMPAIGN_QUOTE_TEMPLATE: campaignQuoteTemplate,
  CAMPAIGN_QUOTE_TEMPLATE_ARRAY: [campaignQuoteTemplate],
  CAMPAIGN_QUOTE_TEMPLATE_ITEM: campaignQuoteTemplateItem,
  CAMPAIGN_QUOTE_TEMPLATE_ITEM_ARRAY: [campaignQuoteTemplateItem],
  CAMPAIGN_QUOTE_TEMPLATE_SECTION: campaignQuoteTemplateSection,
  CAMPAIGN_QUOTE_TEMPLATE_SECTION_ARRAY: [campaignQuoteTemplateSection],
  CAMPAIGN_RURAL_CATEGORY: campaignRuralCategory,
  CAMPAIGN_RURAL_CATEGORY_ARRAY: [campaignRuralCategory],
  CAMPAIGN_SALE_METHOD: campaignSaleMethod,
  CAMPAIGN_SALE_METHOD_ARRAY: [campaignSaleMethod],
  CAMPAIGN_STATUS: campaignStatus,
  CAMPAIGN_STATUS_ARRAY: [campaignStatus],
  CAMPAIGN_TYPE: campaignType,
  CAMPAIGN_TYPE_ARRAY: [campaignType],
  CHART_DATA: chartData,
  COMMENT: comment,
  COMMENT_ARRAY: [comment],
  CONTACT: contact,
  CONTACT_ARRAY: [contact],
  CONTRACT: contract,
  CONTRACT_ARRAY: [contract],
  CONVERSATION: conversation,
  CONVERSATION_ARRAY: [conversation],
  CREDIT_NOTE: creditNote,
  CREDIT_NOTE_ARRAY: [creditNote],
  CREDIT_NOTE_ITEM: creditNoteItem,
  CREDIT_NOTE_ITEM_ARRAY: [creditNoteItem],
  CUSTOM_DEADLINE: customDeadline,
  CUSTOM_DEADLINE_ARRAY: [customDeadline],
  CUSTOM_FIELD: customField,
  CUSTOM_FIELD_ARRAY: [customField],
  CUSTOM_FIELD_SET: customFieldSet,
  CUSTOM_FIELD_SET_ARRAY: [customFieldSet],
  CUSTOM_ITEM: customItem,
  CUSTOM_ITEM_ARRAY: [customItem],
  CUSTOM_ITEM_GROUP: customItemGroup,
  CUSTOM_ITEM_GROUP_ARRAY: [customItemGroup],
  CUSTOM_SHORTCODE: customShortcode,
  CUSTOM_SHORTCODE_ARRAY: [customShortcode],
  DATA_STORE_ITEM: dataStoreItem,
  DATA_STORE_ITEM_ARRAY: [dataStoreItem],
  DEFAULT_QUOTE_ITEM: defaultQuoteItem,
  DEFAULT_QUOTE_ITEM_ARRAY: [defaultQuoteItem],
  DIGITAL_TEMPLATE_ARRAY: [digitalTemplate],
  FAVOURITE_ORDER: favouriteOrder,
  FAVOURITE_ORDER_ARRAY: [favouriteOrder],
  FAVOURITE_ORDER_ITEM: favouriteOrderItem,
  FAVOURITE_ORDER_ITEM_ARRAY: [favouriteOrderItem],
  FINANCE_APPLICATION: financeApplication,
  FINANCE_APPLICATION_ARRAY: [financeApplication],
  FONT: font,
  FONT_ARRAY: [font],
  FONT_FAMILY: fontFamily,
  FONT_FAMILY_ARRAY: [fontFamily],
  GEO_COUNTRY: geoCountry,
  GEO_COUNTRY_ARRAY: [geoCountry],
  GEO_STATE: geoState,
  GEO_STATE_ARRAY: [geoState],
  GEO_SUBURB: geoSuburb,
  GEO_SUBURB_ARRAY: [geoSuburb],
  IMAGE: image,
  IMAGE_ARRAY: [image],
  IMAGE_LIBRARY: imageLibrary,
  IMAGE_LIBRARY_ARRAY: [imageLibrary],
  INTEGRATION: integration,
  INTEGRATION_ARRAY: [integration],
  INTERACTIVE_IMAGE: interactiveImage,
  INTERACTIVE_IMAGE_ARRAY: [interactiveImage],
  INVOICE: invoice,
  INVOICE_ARRAY: [invoice],
  INVOICE_ITEM: invoiceItem,
  INVOICE_ITEM_ARRAY: [invoiceItem],
  LAYOUT_TEMPLATE: layoutTemplate,
  LAYOUT_TEMPLATE_ARRAY: [layoutTemplate],
  LOGIN_SESSION: loginSession,
  LOGIN_SESSION_ARRAY: [loginSession],
  MEDIA_LINK: mediaLink,
  MEDIA_LINK_ARRAY: [mediaLink],
  MICROSITE: microsite,
  MICROSITE_ARRAY: [microsite],
  NOTIFICATION: notification,
  NOTIFICATION_ARRAY: [notification],
  ORDER: order,
  ORDER_ARRAY: [order],
  ORDER_BUNDLE: orderBundle,
  ORDER_BUNDLE_ARRAY: [orderBundle],
  ORDER_BUNDLE_ITEM: orderBundleItem,
  ORDER_BUNDLE_ITEM_ARRAY: [orderBundleItem],
  ORDER_ITEM: orderItem,
  ORDER_ITEM_ARRAY: [orderItem],
  ORDER_ITEM_TASK: orderItemTask,
  ORDER_ITEM_TASK_ARRAY: [orderItemTask],
  ORDER_ITEM_TASK_TYPE: orderItemTaskType,
  ORDER_ITEM_TASK_TYPE_ARRAY: [orderItemTaskType],
  ORDER_LEAD_TIME: orderLeadTime,
  ORDER_LEAD_TIME_ARRAY: [orderLeadTime],
  PAGINATION_RULE: paginationRule,
  PAGINATION_RULE_ARRAY: [paginationRule],
  PAYMENT_METHOD: paymentMethod,
  PAYMENT_METHOD_ARRAY: [paymentMethod],
  PORTAL: portal,
  PORTAL_ARRAY: [portal],
  PORTAL_OPTION: portalOption,
  PORTAL_OPTION_ARRAY: [portalOption],
  PORTAL_OPTION_VALUE: portalOptionValue,
  PORTAL_OPTION_VALUE_ARRAY: [portalOptionValue],
  PRICING_PLAN: pricingPlan,
  PRICING_PLAN_ARRAY: [pricingPlan],
  PRIORITY_CAMPAIGN: priorityCampaign,
  PRIORITY_CAMPAIGN_ARRAY: [priorityCampaign],
  PROCESSING_FEE: processingFee,
  PROCESSING_FEE_ARRAY: [processingFee],
  PROVIDER: provider,
  PROVIDER_ACCOUNT: providerAccount,
  PROVIDER_ACCOUNT_ARRAY: [providerAccount],
  PROVIDER_ARRAY: [provider],
  PROVIDER_DEADLINE_GROUP: providerDeadlineGroup,
  PROVIDER_DEADLINE_GROUP_ARRAY: [providerDeadlineGroup],
  PROVIDER_DISCLAIMER: providerDisclaimer,
  PROVIDER_DISCLAIMER_ARRAY: [providerDisclaimer],
  PROVIDER_ORDER_CODE: providerOrderCode,
  PROVIDER_ORDER_CODE_ARRAY: [providerOrderCode],
  PROVIDER_PACKAGE: providerPackage,
  PROVIDER_PACKAGE_ARRAY: [providerPackage],
  PROVIDER_PACKAGE_ITEM: providerPackageItem,
  PROVIDER_PACKAGE_ITEM_ARRAY: [providerPackageItem],
  PROVIDER_PRICE_LIST: providerPriceList,
  PROVIDER_PRICE_LIST_ARRAY: [providerPriceList],
  PROVIDER_PRICE_LIST_ITEM: providerPriceListItem,
  PROVIDER_PRICE_LIST_ITEM_ARRAY: [providerPriceListItem],
  PROVIDER_PRICE_LIST_ITEM_OPTION: providerPriceListItemOption,
  PROVIDER_PRICE_LIST_ITEM_OPTION_ARRAY: [providerPriceListItemOption],
  PROVIDER_PRICE_LIST_ITEM_OPTION_VALUE: providerPriceListItemOptionValue,
  PROVIDER_PRICE_LIST_ITEM_OPTION_VALUE_ARRAY: [providerPriceListItemOptionValue],
  PROVIDER_PRICE_LIST_PRODUCT_UNLOCK: providerPriceListProductUnlock,
  PROVIDER_PRICE_LIST_PRODUCT_UNLOCK_ARRAY: [providerPriceListProductUnlock],
  PROVIDER_PRODUCT_CODE: providerProductCode,
  PROVIDER_PRODUCT_CODE_ARRAY: [providerProductCode],
  PROVIDER_SERVICE: providerService,
  PROVIDER_SERVICE_ARRAY: [providerService],
  PUBLICATION: publication,
  PUBLICATION_ARRAY: [publication],
  PUBLICATION_BOOKING: publicationBooking,
  PUBLICATION_BOOKING_ARRAY: [publicationBooking],
  PUBLICATION_BOOKING_ITEM: publicationBookingItem,
  PUBLICATION_BOOKING_ITEM_ARRAY: [publicationBookingItem],
  PUBLICATION_COMPATIBLE_PAGINATION: publicationCompatiblePagination,
  PUBLICATION_COMPATIBLE_PAGINATION_ARRAY: [publicationCompatiblePagination],
  PUBLICATION_EDITION: publicationEdition,
  PUBLICATION_EDITION_ARRAY: [publicationEdition],
  PUBLICATION_INSPECTION: publicationInspection,
  PUBLICATION_INSPECTION_ARRAY: [publicationInspection],
  PUBLICATION_OPTION: publicationOption,
  PUBLICATION_OPTION_ARRAY: [publicationOption],
  PUBLICATION_OPTION_VALUE: publicationOptionValue,
  PUBLICATION_OPTION_VALUE_ARRAY: [publicationOptionValue],
  PUBLICATION_ORDER: publicationOrder,
  PUBLICATION_ORDER_ARRAY: [publicationOrder],
  PUBLICATION_PAGINATION_RULE: publicationPaginationRule,
  PUBLICATION_PAGINATION_RULE_ARRAY: [publicationPaginationRule],
  PUBLICATION_PRODUCT: publicationProduct,
  PUBLICATION_PRODUCT_ARRAY: [publicationProduct],
  PUBLICATION_SPECIAL_DEADLINE: publicationSpecialDeadline,
  PUBLICATION_SPECIAL_DEADLINE_ARRAY: [publicationSpecialDeadline],
  ROLE: role,
  ROLE_ARRAY: [role],
  SAVED_ARTWORK: savedArtwork,
  SAVED_ARTWORK_ARRAY: [savedArtwork],
  SAVED_ARTWORK_PAGE: savedArtworkPage,
  SAVED_ARTWORK_PAGE_ARRAY: [savedArtworkPage],
  SERVICE: service,
  SERVICE_ARRAY: [service],
  SERVICE_CATEGORY: serviceCategory,
  SERVICE_CATEGORY_ARRAY: [serviceCategory],
  SERVICE_PRODUCT: serviceProduct,
  SERVICE_PRODUCT_ARRAY: [serviceProduct],
  SMS_LOG: smsLog,
  SMS_LOG_ARRAY: [smsLog],
  STATUS: status,
  STATUS_ARRAY: [status],
  SUBSCRIBER: subscriber,
  SUBSCRIBER_ARRAY: [subscriber],
  SYSTEM: system,
  SYSTEM_ARRAY: [system],
  TAG: tag,
  TAG_ARRAY: [tag],
  TEAM: team,
  TEAM_ARRAY: [team],
  TEAM_MEMBER: teamMember,
  TEAM_MEMBER_ARRAY: [teamMember],
  TEMPLATE_PAGE: templatePage,
  TEMPLATE_PAGE_ARRAY: [templatePage],
  TEMPLATE_PAGE_CATEGORY: templatePageCategory,
  TEMPLATE_PAGE_CATEGORY_ARRAY: [templatePageCategory],
  TRACKING_LINK: trackingLink,
  TRACKING_LINK_ARRAY: [trackingLink],
  TRAINING_COURSE: trainingCourse,
  TRAINING_COURSE_ARRAY: [trainingCourse],
  TRAINING_LESSON: trainingLesson,
  TRAINING_LESSON_ARRAY: [trainingLesson],
  TRAINING_MODULE: trainingModule,
  TRAINING_MODULE_ARRAY: [trainingModule],
  USER: user,
  USER_ARRAY: [user],
  WEBHOOK: webhook,
  WEBHOOK_ARRAY: [webhook],
// END SCHEMA DEFINITION
}

export default Schemas
